<template>
  <span></span>
</template>
<script setup lang="ts">
import { computed, watchEffect, onMounted } from "vue";
import {
  getLanguageName,
  getLocationName,
} from "@/apps/person-registration/shared-helpers/language.helper";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import useClerkPersistState from "@/apps/merchant3/hooks/useClerkPersistState";
import useMerchantPersistState from "@/apps/merchant3/hooks/useMerchantPersistState";
import useCartPersistState from "@/apps/merchant3/hooks/useCartPersistState";

const route = useRoute();
const router = useRouter();
const userTag = route.params.userTag || null;
const currentPage = router.currentRoute.value.name?.toString();

let app = "personRegistration";
if (currentPage && currentPage.includes("M3_")) {
  app = "M3";
}
const store = useStore();

const chatBoxParams = computed(() => {
  if (app === "M3") {
    return {
      clerkToken: store.state.clerk?.clerk?.chatBotApiToken,
      salesClerkId: store.state.clerk?.clerk?.salesClerkId,
      name: `${store.state.merchant?.merchant?.merchantName}/${
        store.state.clerk?.clerk?.salesClerkName
      }${store.state.carts?.cartTag || ""}`,
      country: store.state.merchant?.merchant?.country,
      userType: "clerk",
      language: getLanguageName(),
    };
  } else {
    return {
      clerkToken: null,
      salesClerkId: null,
      name: `Registration tag: ${userTag}`,
      country: getLocationName(),
      userType: "personRegistration",
      language: getLanguageName(),
    };
  }
});

const addAda = (params) => {
  var ada = document.createElement("script");
  ada.src = "https://static.ada.support/embed2.js";
  ada.id = "__ada";
  ada.setAttribute("data-handle", "payjoy-es");
  document.body.appendChild(ada);
  window.adaSettings = {
    metaFields: params,
  };
};

onMounted(() => {
  if (store.state.carts?.cartTag) useCartPersistState(() => true);
  if (currentPage && currentPage.includes("M3_")) {
    useClerkPersistState(() => true);
    useMerchantPersistState(() => true);
  }
});

const isAddaScriptLoaded = () => {
  var scripts = document.getElementsByTagName("script");
  for (var i = scripts.length - 1; i >= 0; i--) {
    if (scripts[i].id === "__ada") return true;
  }
  return false;
};

if (
  app == "personRegistration" &&
  getLanguageName() === "es" &&
  !isAddaScriptLoaded()
) {
  addAda(chatBoxParams.value);
}

watchEffect(() => {
  if (
    app === "M3" &&
    store.state.clerk?.clerk?.chatBotApiToken &&
    store.state.clerk?.clerk?.salesClerkId &&
    store.state.clerk?.clerk?.salesClerkName &&
    store.state.merchant?.merchant?.merchantName &&
    store.state.merchant?.merchant?.country &&
    getLanguageName() === "es" && //TODO: fix chatbot to work across languages
    !isAddaScriptLoaded()
  ) {
    addAda(chatBoxParams.value);
  }
});
</script>
